function ErrorBoundary() {
  return (
    <div className='error-container'>
      <div className='min-h-screen flex flex-col items-center justify-center bg-slate-50 p-4'>
        <div className='max-w-md w-full mx-auto flex flex-col items-center text-center space-y-6'>
          <div className='w-64 sm:w-72 mb-1'>
            <img
              alt='Eklipx Research Logo'
              width='400'
              height='200'
              decoding='async'
              data-nimg='1'
              style={{ color: 'transparent' }}
              src='https://hebbkx1anhila5yf.public.blob.vercel-storage.com/eklipx-research%20%281%29-jh4CAYFZHNt4arg1MkJug8OvcjG8my.svg'
            />
          </div>
          <h1 className='text-2xl sm:text-3xl font-extrabold text-gray-800'>Something went wrong</h1>
          <p className='text-lg font-medium text-gray-600'>
            Sorry, an unexpected error has occurred. Please try again or contact support.
          </p>

          <div className='mt-8 text-sm text-gray-500'>© 2025 Eklipx Research</div>
        </div>
      </div>
    </div>
  );
}

export default ErrorBoundary;
